export default __webpack_public_path__ + "static/favicon-c1f3226579ce01747867fd06a4398948.ico";